/* npm imports */
import firebase from "firebase";
import * as firebaseui from "firebaseui";

import store from "../store";
import { firebase as config } from "../config";

const firebaseApp = firebase.initializeApp(config);
export const firebasePerformance = firebaseApp.performance();
export default firebaseApp;

// Initialize Cloud Firestore through Firebase
export const db = firebase.firestore();

export const auth = firebase.auth();

export const functions = firebaseApp.functions("europe-west1");

export const authUi = new firebaseui.auth.AuthUI(auth);

store.state.user = auth.currentUser || {};

auth.onAuthStateChanged(user => {
  const loggedinUser = user ? { displayName: user.displayName, photoURL: user.photoURL, isAnonymous: user.isAnonymous, userId: user.uid, _authData: user } : {};
  if (user) {
    if (Array.isArray(user.providerData) && user.providerData.length > 0) {
      const providerData = user.providerData[0];
      if (providerData) {
        if (!loggedinUser.displayName) {
          loggedinUser.displayName = providerData.displayName;
        }
        if (!loggedinUser.photoURL) {
          loggedinUser.photoURL = providerData.photoURL;
        }
      }
    }
  } else {
    auth.signInAnonymously().catch(error => {
      // Handle Errors here.
      if (window.console && window.console.log) {
        window.console.log("Error signing in anonymously");
        window.console.log(error);
      }
    });
  }
  store.dispatch("login", loggedinUser);
});
